<div class="dialog-viewer">
    <h2 mat-dialog-title>Create Simulator</h2>
    <form [formGroup]="form" (ngSubmit)="submit(form)">
        <mat-dialog-content>
            <div class="container-fluid">
                <div class="row">
                    <div class="col">
                        <mat-form-field>
                            <mat-label>Bay Number</mat-label>
                            <input matInput required name="bayNumber" id="bayNumber" placeholder="Bay Number"
                                type="number" formControlName="bayNumber" />
                            <mat-error *ngIf="form.get('bayNumber').errors?.required">Bay Number is required
                            </mat-error>
                            <mat-error *ngIf="form.get('bayNumber').errors?.validationErrors">
                                {{ form.get("bayNumber").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field>
                            <mat-label>Bay Name (Description)</mat-label>
                            <input required matInput name="bayName" id="bayName" placeholder="Bay Name" type="text"
                                formControlName="bayName" />
                            <mat-error *ngIf="form.get('bayName').errors?.required">Bay Name is required
                            </mat-error>
                            <mat-error *ngIf="form.get('bayName').errors?.validationErrors">
                                {{ form.get("bayName").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field>
                            <mat-label>Capacity</mat-label>
                            <input required matInput name="capacity" id="capacity" placeholder="Capacity" type="number"
                                formControlName="capacity" />
                            <mat-error *ngIf="form.get('capacity').errors?.required">Capacity is required
                            </mat-error>
                            <mat-error *ngIf="form.get('capacity').errors?.validationErrors">
                                {{ form.get("capacity").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="text-center">
                <button mat-raised-button type="submit" [disabled]="isLoading">Save</button>
                <button mat-raised-button (click)="dialogRef.close('cancel')" color="warn"
                    [disabled]="isLoading">Cancel</button>
            </div>
        </mat-dialog-actions>
    </form>
</div>